/* eslint-disable no-unused-vars */
import { getAppHost } from 'helpers'
import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'

// List AI Tools - Updated to support cursor-based pagination
export const list = async (
  app,
  appSettings,
  pageNo = 1,
  searchText = '',
  paginationPayload = '',
  agentUid,
) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/tools/agent/${agentUid}`

    const params = new URLSearchParams()
    if (pageNo) params.append('page', pageNo)
    if (searchText) params.append('search', searchText)

    // Build URL with pagination payload (affix=append&createdAt=timestamp or affix=prepend&createdAt=timestamp)
    let url = baseURL
    if (paginationPayload) {
      url = `${baseURL}?limit=10&${paginationPayload}`
      // Add additional params if they exist
      if (params.toString()) {
        url = `${url}&${params.toString()}`
      }
    } else {
      // Default first load with limit
      const baseParams = params.toString()
      url = baseParams ? `${baseURL}?limit=10&${baseParams}` : `${baseURL}?limit=10`
    }

    const response = await axios.get(url, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    // Return format expected by cursor-based pagination saga
    return response.data
  } catch (error) {
    throw error
  }
}

// Get single AI Tool
export const get = async (app, appSettings, toolName) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/agent-builder/tools/${encodeURIComponent(toolName)}`

    const response = await axios.get(baseURL, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Get AI Tool Edit Form
export const getEditForm = async (app, appSettings, toolName) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/agent-builder/forms/tool-edit/${encodeURIComponent(toolName)}`

    const response = await axios.get(baseURL, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Add AI Tool
export const add = async (app, appSettings, agentId, tools) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents/${agentId}/tools/add`

    const response = await axios.patch(baseURL, tools, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
export const remove = async (app, appSettings, agentId, tools) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents/${agentId}/tools/remove`

    const response = await axios.patch(baseURL, tools, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Update AI Tool
export const update = async (app, appSettings, toolName, toolData) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/agent-builder/tools/${encodeURIComponent(toolName)}`

    const response = await axios.put(baseURL, toolData, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// tools action
// Get AI Tool by Name
export const getActionWithinTools = async (
  app,
  appSettings,
  slug = 'gmail',
  agentUid,
  paginationPayload = '',
) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents/${agentUid}/tools/${slug}/actions`

    // Build URL with pagination payload (affix=append&createdAt=timestamp or affix=prepend&createdAt=timestamp)
    let url = baseURL
    if (paginationPayload) {
      url = `${baseURL}?limit=10&${paginationPayload}`
    } else {
      // Default first load
      url = `${baseURL}?limit=10`
    }

    const response = await axios.get(url, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Add AI Tool
export const addAction = async (app, appSettings, agentId, tools, slug) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents/${agentId}/tools/${slug}/actions/add`

    const response = await axios.patch(baseURL, tools, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
export const removeAction = async (app, appSettings, agentId, tools, slug) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents/${agentId}/tools/${slug}/actions/remove`

    const response = await axios.patch(baseURL, tools, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Authenticate AI Tool
export const authenticateCustomApiTool = async (app, appSettings, agentId, toolName, authMeta) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents/${agentId}/tools/${encodeURIComponent(toolName)}/authenticate`

    const payload = {
      authMeta,
    }

    const response = await axios.post(baseURL, payload, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Create Custom API Tool
export const createCustomApiTool = async (app, appSettings, customApiToolData) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/api-tools`

    const response = await axios.post(baseURL, customApiToolData, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Update Custom API Tool
export const updateCustomApiTool = async (app, appSettings, customApiToolData) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/api-tools/${encodeURIComponent(customApiToolData.slug)}`

    const response = await axios.patch(baseURL, customApiToolData, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Delete Custom API Tool
export const deleteCustomApiTool = async (app, appSettings, slug) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/api-tools/${encodeURIComponent(slug)}`

    const response = await axios.delete(baseURL, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// List Custom API Tools
export const listCustomApiTools = async (
  app,
  appSettings,
  pageNo = 1,
  searchText = '',
  paginationPayload = '',
) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/api-tools`

    // Build URL with pagination payload (affix=append&createdAt=timestamp or affix=prepend&createdAt=timestamp)
    let url = baseURL
    if (paginationPayload) {
      url = `${baseURL}?limit=10&${paginationPayload}`
    } else {
      // Default first load
      url = `${baseURL}?limit=10`
    }

    const response = await axios.get(url, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Add AI Tool
export const addApiTool = async (app, appSettings, agentId, tools) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents/${agentId}/api-tools/add`

    const response = await axios.patch(baseURL, tools, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
export const removeApiTool = async (app, appSettings, agentId, tools) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents/${agentId}/api-tools/remove`

    const response = await axios.patch(baseURL, tools, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
